import { API_URL } from '../../utils/config';
import React from 'react';
import axios from 'axios';
import { Button, Modal, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

var UpdateZlecenie = React.createClass({

	getInitialState: function() {
		this.getDictListwy();
		return {
			updateObject: {
				id: '',
				cena: '',
				grubosc: '',
				hdf: '',
				kosztUslugi: '',
				lustro: '',
				numerListwy: '',
				numerPass: '',
				operator: '',
				punktSprzedazy: '',
				szerokosc: '',
				szklo: '',
				uwagi: '',
				wysokosc: '',
				zawieszka: '',
				dataZlozenia: '',
				imie: '',
				nazwisko: '',
				telefon: '',
				email: '',
				nip: '',
				czyZrealizowane: '',
				zaliczka: '',
				pozostalaDoplata: '',
				dataOdbioru: '',
				czyPass: '',
				szlif: false,
				faza: false,
				krosno: false,
				folia: false,
				iloscSztuk: 1,
			},
			dictListwa:{
				id: '',
				numerListwy: '',
				cenaZaMb: ''
			},
			dataDictListwy: null,
		}
    },

		render: function() {

			return (
				<Modal show={this.props.parent.state.showUpdateModal}>
					<Modal.Header>
						<Modal.Title>Aktualizuj Zlecenie</Modal.Title>
					</Modal.Header>
					<Modal.Body>
							<div className="row">
								<div className="col-sm-4">
									<ControlLabel>Imię: </ControlLabel>
								</div>
								<div className="col-sm-8">
								<FormControl
									type="text"
									placeholder="Imię"
									value={this.state.updateObject.imie}
									onChange={this.onUpdateZlecenieImieChange} />
								</div>
							</div>

							<div className="row">
								<div className="col-sm-4">
									<ControlLabel>Nazwisko: </ControlLabel>
								</div>
								<div className="col-sm-8">
								<FormControl
									type="text"
									placeholder="Nazwisko"
									value={this.state.updateObject.nazwisko}
									onChange={this.onUpdateZlecenieNazwiskoChange} />
								</div>
							</div>

							<div className="row">
								<div className="col-sm-4">
									<ControlLabel>Telefon: </ControlLabel>
								</div>
								<div className="col-sm-8">
								<FormControl
									type="text"
									placeholder="Telefon"
									value={this.state.updateObject.telefon}
									onChange={this.onUpdateZlecenieTelefonChange} />
								</div>
							</div>

							<div className="row">
								<div className="col-sm-4">
									<ControlLabel>Email: </ControlLabel>
								</div>
								<div className="col-sm-8">
								<FormControl
									type="text"
									placeholder="Email"
									value={this.state.updateObject.email}
									onChange={this.onUpdateZlecenieEmailChange} />
								</div>
							</div>

							<div className="row">
								<div className="col-sm-4">
									<ControlLabel>NIP: </ControlLabel>
								</div>
								<div className="col-sm-8">
								<FormControl
									type="text"
									placeholder="NIP"
									value={this.state.updateObject.nip}
									onChange={this.onUpdateZlecenieNipChange} />
								</div>
							</div>

							<div className="row">
								<div className="col-sm-4">
									<ControlLabel>Numer Listwy: </ControlLabel>
								</div>
								<div className="col-sm-8">
								<FormControl
									type="text"
									placeholder="Numer Listwy"
									value={this.state.updateObject.numerListwy}
									onChange={this.onUpdateZlecenieNrListwyChange} />
									<ControlLabel>Cena za mb: {this.dictListwa ? (this.dictListwa.cenaZaMb ? this.dictListwa.cenaZaMb + ' zł' : '0.00 zł') : '0.00 zł'}</ControlLabel>
								</div>
							</div>

							<div className="row">
								<div className="col-sm-4">
									<ControlLabel>Szerokość: </ControlLabel>
								</div>
								<div className="col-sm-8">
								<FormControl
									type="text"
									placeholder="Szerokość"
									value={this.state.updateObject.szerokosc}
									onChange={this.onUpdateZlecenieSzerokoscChange} />
								</div>
							</div>

							<div className="row">
								<div className="col-sm-4">
									<ControlLabel>Wysokość: </ControlLabel>
								</div>
								<div className="col-sm-8">
								<FormControl
									type="text"
									placeholder="Wysokość"
									value={this.state.updateObject.wysokosc}
									onChange={this.onUpdateZlecenieWysokoscChange} />
								</div>
							</div>

							<div className="row">
								<div className="col-sm-4">
									<ControlLabel>Grubość: </ControlLabel>
								</div>
								<div className="col-sm-8">
								<FormControl
									type="text"
									placeholder="Grubość"
									value={this.state.updateObject.grubosc}
									onChange={this.onUpdateZlecenieGruboscChange} />
								</div>
							</div>

							<div className="row">
								<div className="col-sm-4">
									<ControlLabel>Numer passparteau: </ControlLabel>
								</div>
								<div className="col-sm-8">
								<FormControl
									type="text"
									placeholder="Numer passparteau"
									value={this.state.updateObject.numerPass}
									onChange={this.onUpdateZlecenieNrPassChange} />
								</div>
							</div>

							<div className="row">
								<div className="col-sm-4">
									<ControlLabel>Koszt usługi: </ControlLabel>
								</div>
								<div className="col-sm-8">
								<FormControl
									type="text"
									placeholder="Koszt usługi"
									value={this.state.updateObject.kosztUslugi}
									onChange={this.onUpdateZlecenieKosztUslugiChange} />
								</div>
							</div>

							<div className="row">
								<div className="col-sm-4">
									<ControlLabel>Szkło: </ControlLabel>
								</div>
								<div className="col-sm-8">
									<select className="form-control" id="szklo"
												value={this.state.updateObject.szklo}
												onChange={this.onUpdateZlecenieSzkloChange} >
										<option>Wybierz typ</option>
				            <option>Zwykłe</option>
				            <option>Antyrefleks</option>
				            <option>Muzealne</option>
				          </select>
								</div>
							</div>

							<div className="row" style={{marginBottom: '6px'}}>
								<div className="col-sm-4"><label><input type="checkbox" checked={this.state.updateObject.hdf} onChange={this.onUpdateZlecenieHdfChange} /> HDF</label></div>
								<div className="col-sm-4"><label><input type="checkbox" checked={this.state.updateObject.zawieszka} onChange={this.onUpdateZlecenieZawieszkaChange} /> Zawieszka</label></div>
								<div className="col-sm-4"><label><input type="checkbox" checked={this.state.updateObject.lustro} onChange={this.onUpdateZlecenieLustroChange} /> Lustro</label></div>
							</div>
							<div className="row" style={{marginBottom: '6px'}}>
								<div className="col-sm-4"><label><input type="checkbox" checked={this.state.updateObject.czyPass} onChange={this.onUpdateZlecenieCzyPassChange} /> Passpartout</label></div>
								<div className="col-sm-4"><label><input type="checkbox" checked={this.state.updateObject.szlif} onChange={this.onUpdateZlecenieSzlifChange} /> Szlif (30/mb)</label></div>
								<div className="col-sm-4"><label><input type="checkbox" checked={this.state.updateObject.faza} onChange={this.onUpdateZlecenieFazaChange} /> Faza (50/mb)</label></div>
							</div>
							<div className="row" style={{marginBottom: '6px'}}>
								<div className="col-sm-4"><label><input type="checkbox" checked={this.state.updateObject.krosno} onChange={this.onUpdateZlecenieKrosnoChange} /> Krosno (35/mb)</label></div>
								<div className="col-sm-4"><label><input type="checkbox" checked={this.state.updateObject.folia} onChange={this.onUpdateZlecenieFoliaChange} /> Folia (15/m²)</label></div>
							</div>

							<div className="row">
								<div className="col-sm-4">
									<ControlLabel>Ilość sztuk: </ControlLabel>
								</div>
								<div className="col-sm-8">
								<FormControl
									type="number"
									min="1"
									placeholder="1"
									value={this.state.updateObject.iloscSztuk}
									onChange={this.onUpdateZlecenieIloscSztukChange} />
								</div>
							</div>

<div className="row">
								<div className="col-sm-4">
									<ControlLabel>Punkt sprzedaży: </ControlLabel>
								</div>
								<div className="col-sm-8">
									<select className="form-control" id="punktSprzedazy"
												value={this.state.updateObject.punktSprzedazy}
												onChange={this.onUpdateZleceniepunktSprzedazyChange} >
										<option>Wybierz punkt</option>
										<option>Castorama</option>
										<option>Arena</option>
										<option>Domar</option>
									</select>
								</div>
							</div>

							<div className="row">
								<div className="col-sm-4">
									<ControlLabel>Sprzedawca: </ControlLabel>
								</div>
								<div className="col-sm-8">
									<select className="form-control" id="punktSprzedazy"
												value={this.state.updateObject.operator}
												onChange={this.onUpdateZlecenieOperatorChange} >
										<option>Wybierz sprzedawcę</option>
										<option>Jerzy</option>
										<option>Natalia</option>
										<option>Klara</option>
										<option>Klaudia</option>
										<option>Bartek</option>
									</select>
								</div>
							</div>

							<div className="row">
								<div className="col-sm-4">
									<ControlLabel>Uwagi: </ControlLabel>
								</div>
								<div className="col-sm-8">
								<FormControl
									type="text"
									placeholder="Uwagi"
									rows="3"
									value={this.state.updateObject.uwagi}
									onChange={this.onUpdateZlecenieUwagiChange} />
								</div>
							</div>

							<div className="row">
								<div className="col-sm-4">
									<ControlLabel>Zaliczka: </ControlLabel>
								</div>
								<div className="col-sm-8">
								<FormControl
									type="text"
									placeholder="Zaliczka"
									value={this.state.updateObject.zaliczka}
									onChange={this.onUpdateZlecenieZaliczkaChange} />
								</div>
							</div>

					</Modal.Body>
					<Modal.Footer>
					 <strong>Cena: {this.state.updateObject.cena ? parseFloat(this.state.updateObject.cena).toFixed(2) + ' zł' : '0.00 zł'}          </strong>
					 <strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
	 				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>
						<Button onClick={this.props.parent.closeUpdateModal}>Zamknij</Button>
						<Button bsStyle="primary" onClick={this.onUpdateBtnClicked}>Aktualizuj</Button>
					</Modal.Footer>
				</Modal>
			);
		},

	fillUpdateObject: function() {
    	var selectedZlecenie = this.props.parent.getZlecenieById(this.props.parent.state.selectedZlecenieIds[0]);

		  this.state.updateObject = {
			id: selectedZlecenie.id,
			cena: selectedZlecenie.cena,
			grubosc: selectedZlecenie.grubosc,
			hdf: selectedZlecenie.hdf,
			kosztUslugi: selectedZlecenie.kosztUslugi,
			lustro: selectedZlecenie.lustro,
			numerListwy: selectedZlecenie.numerListwy,
			numerPass: selectedZlecenie.numerPass,
			operator: selectedZlecenie.operator,
			punktSprzedazy: selectedZlecenie.punktSprzedazy,
			szerokosc: selectedZlecenie.szerokosc,
			szklo: selectedZlecenie.szklo,
			uwagi: selectedZlecenie.uwagi,
			wysokosc: selectedZlecenie.wysokosc,
			zawieszka: selectedZlecenie.zawieszka,
			dataZlozenia: selectedZlecenie.dataZlozenia,
			imie: selectedZlecenie.imie,
			nazwisko: selectedZlecenie.nazwisko,
			telefon: selectedZlecenie.telefon,
			email: selectedZlecenie.email || '',
			nip: selectedZlecenie.nip || '',
			zaliczka: selectedZlecenie.zaliczka,
			czyZrealizowane: selectedZlecenie.czyZrealizowane,
			pozostalaDoplata: selectedZlecenie.pozostalaDoplata,
			dataOdbioru: selectedZlecenie.dataOdbioru,
			czyPass: selectedZlecenie.czyPass,
			szlif: selectedZlecenie.szlif || false,
			faza: selectedZlecenie.faza || false,
			krosno: selectedZlecenie.krosno || false,
			folia: selectedZlecenie.folia || false,
			iloscSztuk: selectedZlecenie.iloscSztuk || 1,
		}
	},

	clearUpdateObject: function() {
		this.state.updateObject.id = '';
		this.state.updateObject.imie = '';
		this.state.updateObject.nazwisko = '';
		this.state.updateObject.telefon = '';
		this.state.updateObject.numerListwy = '';
		this.state.updateObject.szerokosc = '';
		this.state.updateObject.wysokosc = '';
		this.state.updateObject.grubosc = '';
		this.state.updateObject.cena = '';
		this.state.updateObject.numerPass = '';
		this.state.updateObject.szklo = '';
		this.state.updateObject.hdf = '';
		this.state.updateObject.kosztUslugi = '';
		this.state.updateObject.lustro = '';
		this.state.updateObject.operator = '';
		this.state.updateObject.uwagi = '';
		this.state.updateObject.punktSprzedazy = '';
		this.state.updateObject.zawieszka = '';
		this.state.updateObject.dataZlozenia = '';
		this.state.updateObject.czyZrealizowane = '';
		this.state.updateObject.zaliczka = '';
		this.state.updateObject.pozostalaDoplata = '';
		this.state.updateObject.dataOdbioru = '';
		this.state.updateObject.czyPass = '';
		this.state.updateObject.email = '';
		this.state.updateObject.nip = '';
		this.state.updateObject.szlif = false;
		this.state.updateObject.faza = false;
		this.state.updateObject.krosno = false;
		this.state.updateObject.folia = false;
		this.state.updateObject.iloscSztuk = 1;
	},

	onUpdateZlecenieImieChange: function(event) {
		this.state.updateObject.imie = event.target.value;
		this.forceUpdate();
	},

	onUpdateZlecenieNazwiskoChange: function(event) {
		this.state.updateObject.nazwisko = event.target.value;
		this.forceUpdate();
	},

	onUpdateZlecenieTelefonChange: function(event) {
		this.state.updateObject.telefon = event.target.value;
		this.forceUpdate();
	},

	onUpdateZlecenieNrListwyChange: function(event) {
		this.state.updateObject.numerListwy = event.target.value;
    this.wyliczCene();
		this.forceUpdate();
	},

	onUpdateZlecenieNrPassChange: function(event) {
		this.state.updateObject.numerPass = event.target.value;
		this.wyliczCene();
		this.forceUpdate();
	},

	onUpdateZlecenieSzerokoscChange: function(event) {
		this.state.updateObject.szerokosc = event.target.value.replace(/,/g, '.');
		this.wyliczCene();
	  this.forceUpdate();
	},
	onUpdateZlecenieWysokoscChange: function(event) {
		this.state.updateObject.wysokosc = event.target.value.replace(/,/g, '.');
		this.wyliczCene();
		this.forceUpdate();
	},

	onUpdateZlecenieGruboscChange: function(event) {
		this.state.updateObject.grubosc = event.target.value.replace(/,/g, '.');
		this.wyliczCene();
		this.forceUpdate();
	},

	onUpdateZlecenieSzkloChange: function(event) {
		this.state.updateObject.szklo = event.target.value;
		this.forceUpdate();
		this.wyliczCene();
	},

	onUpdateZlecenieHdfChange: function(event) {
		this.state.updateObject.hdf = !this.state.updateObject.hdf;
		this.wyliczCene();
		this.forceUpdate();
	},

	onUpdateZlecenieKosztUslugiChange: function(event) {
		this.state.updateObject.kosztUslugi = event.target.value.replace(/,/g, '.');
		this.wyliczCene();
		this.forceUpdate();
	},

	onUpdateZlecenieLustroChange: function(event) {
		this.state.updateObject.lustro = !this.state.updateObject.lustro;
		this.wyliczCene();
		this.forceUpdate();
	},

	onUpdateZlecenieCzyPassChange: function(event) {
		this.state.updateObject.czyPass = !this.state.updateObject.czyPass;
    this.wyliczCene();
		this.forceUpdate();
	},

	onUpdateZlecenieOperatorChange: function(event) {
		this.state.updateObject.operator = event.target.value;
		this.forceUpdate();
	},

	onUpdateZlecenieUwagiChange: function(event) {
		this.state.updateObject.uwagi = event.target.value;
		this.forceUpdate();
	},

	onUpdateZleceniepunktSprzedazyChange: function(event) {
		this.state.updateObject.punktSprzedazy = event.target.value;
		this.forceUpdate();
	},

	onUpdateZlecenieZawieszkaChange: function(event) {
		this.state.updateObject.zawieszka = !this.state.updateObject.zawieszka;
		this.wyliczCene();
		this.forceUpdate();
	},

	onUpdateZlecenieEmailChange: function(event) {
		this.state.updateObject.email = event.target.value;
		this.forceUpdate();
	},

	onUpdateZlecenieNipChange: function(event) {
		this.state.updateObject.nip = event.target.value;
		this.forceUpdate();
	},

	onUpdateZlecenieSzlifChange: function(event) {
		this.state.updateObject.szlif = !this.state.updateObject.szlif;
		this.wyliczCene();
		this.forceUpdate();
	},

	onUpdateZlecenieFazaChange: function(event) {
		this.state.updateObject.faza = !this.state.updateObject.faza;
		this.wyliczCene();
		this.forceUpdate();
	},

	onUpdateZlecenieKrosnoChange: function(event) {
		this.state.updateObject.krosno = !this.state.updateObject.krosno;
		this.wyliczCene();
		this.forceUpdate();
	},

	onUpdateZlecenieFoliaChange: function(event) {
		this.state.updateObject.folia = !this.state.updateObject.folia;
		this.wyliczCene();
		this.forceUpdate();
	},

	onUpdateZlecenieIloscSztukChange: function(event) {
		this.state.updateObject.iloscSztuk = parseInt(event.target.value) || 1;
		this.wyliczCene();
		this.forceUpdate();
	},

	onUpdateZlecenieZaliczkaChange: function(event) {
		this.state.updateObject.zaliczka = event.target.value.replace(/,/g, '.');
		this.wyliczCene();
		this.forceUpdate();
	},

	wyliczCene: function() {
		this.dictListwa = this.getListwaByNrListwy(this.state.updateObject.numerListwy);

		var dlListwy = (parseFloat(parseFloat(this.state.updateObject.wysokosc * 2) + parseFloat(this.state.updateObject.szerokosc * 2)) + parseFloat(this.state.updateObject.grubosc * 8)) / 100
		var kosztListwy = this.dictListwa ? (dlListwy * (this.dictListwa ? parseFloat(this.dictListwa.cenaZaMb) : 1)) : 0.00

		var kosztUslugi =  (this.state.updateObject.kosztUslugi ? parseFloat(this.state.updateObject.kosztUslugi) : 0.00)

		var pole = parseFloat((this.state.updateObject.wysokosc / 100) * (this.state.updateObject.szerokosc) / 100)
		
		var kosztSzkla = 0.00
	    if (this.state.updateObject.szklo && this.state.updateObject.szklo == 'Zwykłe') kosztSzkla = parseFloat(80 * pole)
	    if (this.state.updateObject.szklo && this.state.updateObject.szklo == 'Antyrefleks') kosztSzkla = parseFloat(120 * pole)
	    if (this.state.updateObject.szklo && this.state.updateObject.szklo == 'Muzealne') kosztSzkla = parseFloat(600 * pole)
		//var kosztSzkla = this.state.updateObject.szklo ? parseFloat(70 * pole) : 0.00
		var kosztPass = this.state.updateObject.czyPass ? parseFloat(90 * pole) : 0.00
		var kostLustra = this.state.updateObject.lustro ? parseFloat(200 * pole) : 0.00
		var kosztHdf =  this.state.updateObject.hdf ?  parseFloat(78 * pole) : 0.00
		var kosztZawieszki = this.state.updateObject.zawieszka ? parseFloat(3.10) : 0.00

		var kosztSzlifu = this.state.updateObject.szlif ? parseFloat(30 * dlListwy) : 0.00;
		var kosztFazy = this.state.updateObject.faza ? parseFloat(50 * dlListwy) : 0.00;
		var kosztKrosna = this.state.updateObject.krosno ? parseFloat(35 * dlListwy) : 0.00;
		var kosztFolii = this.state.updateObject.folia ? parseFloat(15 * pole) : 0.00;

		kosztListwy = (isNaN(kosztListwy) ? 0.00 : kosztListwy);
		kosztUslugi = (isNaN(kosztUslugi) ? 0.00 : kosztUslugi);
		kosztSzkla = (isNaN(kosztSzkla) ? 0.00 : kosztSzkla);
		kosztPass = (isNaN(kosztPass) ? 0.00 : kosztPass);
		kostLustra = (isNaN(kostLustra) ? 0.00 : kostLustra);
		kosztHdf = (isNaN(kosztHdf) ? 0.00 : kosztHdf);
		kosztZawieszki = (isNaN(kosztZawieszki) ? 0.00 : kosztZawieszki);
		kosztSzlifu = (isNaN(kosztSzlifu) ? 0.00 : kosztSzlifu);
		kosztFazy = (isNaN(kosztFazy) ? 0.00 : kosztFazy);
		kosztKrosna = (isNaN(kosztKrosna) ? 0.00 : kosztKrosna);
		kosztFolii = (isNaN(kosztFolii) ? 0.00 : kosztFolii);

		if (this.state.updateObject.szklo == 'false') this.state.updateObject.szklo = 'NIE'
		if (this.state.updateObject.szklo == 'Wybierz typ' || this.state.updateObject.szklo == 'NIE') kosztSzkla = 0.00

		var cenaJednostkowa = parseFloat(kosztListwy + kosztUslugi + kosztSzkla + kosztPass + kostLustra + kosztHdf + kosztZawieszki + kosztSzlifu + kosztFazy + kosztKrosna + kosztFolii);
		var iloscSztuk = parseInt(this.state.updateObject.iloscSztuk) || 1;
		this.state.updateObject.cena = cenaJednostkowa * iloscSztuk;

		this.forceUpdate();
	},

	getDictListwy: function() {
		axios.get(API_URL + '/dictListwy')
		.then(function (dictListwy) {
			this.setState({dataDictListwy: dictListwy.data});
		}.bind(this));
	},

	getListwaByNrListwy: function(numerListwy) {
		for(var i in this.state.dataDictListwy) {
			if(this.state.dataDictListwy[i].numerListwy == numerListwy) {
				return this.state.dataDictListwy[i];
			}
		}
		return 'brak';
	},

	onUpdateBtnClicked: function() {
		axios.put(API_URL + '/zlecenie/' + this.state.updateObject.id, this.state.updateObject)
			.then(function (response) {
				this.props.parent.closeUpdateModal();
				this.props.parent.refreshTable();
			}.bind(this))
			.catch(function (error) {
				alert("Błędnie wprowadzone dane");
				console.log(error);
			});
	}
});

export default UpdateZlecenie;



// WEBPACK FOOTER //
// ./src/components/Zlecenie/UpdateZlecenie.js